export interface ContentLinkBase {
  testId: string
  title: string
  description?: string
  icon?: string
}

export interface ArticleIdMap {
  acceptance: string
  production: string
}

export interface ContentLinkArticle extends ContentLinkBase {
  id?: ArticleIdMap
  slug: string
  href?: string
}

export interface ContentLinkHref extends ContentLinkBase {
  href: string
}

export type ContentLink = ContentLinkArticle | ContentLinkHref

export type ContentRedirectTo = Pick<ContentLinkArticle, 'id' | 'slug'>

export interface ContentRedirect {
  from: string
  to: ContentRedirectTo
}

export const FOOTER_LINKS_COLOFON: ContentLink[] = [
  {
    testId: 'Databeleid',
    title: 'Databeleid',
    id: {
      acceptance: '29160257-dd4b-4349-a5df-d6f7715615ed',
      production: '8af0598f-12a0-47c5-9327-938fade1159a',
    },
    href: 'https://www.amsterdam.nl/innovatie/digitalisering-technologie/data/',
  },
  {
    testId: 'OverDeOrganisatie',
    title: 'Over de organisatie',
    slug: '/over-ons/',
  },
  {
    testId: 'OverHetDataplatform',
    title: 'Over het dataplatform',
    slug: '/dataplatform-services/',
  },
  {
    testId: 'OverDezeSite',
    title: 'Over deze site',
    id: {
      acceptance: '6b474539-32fb-4a1c-929a-bbfefadadc08',
      production: 'a5176bed-cad4-46d2-b501-a628370c9099',
    },
    slug: '/over-deze-site/',
  },
]

export const FOOTER_LINKS_NEWSLETTER: ContentLinkHref[] = [
  {
    testId: 'SocialNieuwsbriefOIS',
    title: 'Nieuwsbrief I-domein inschrijven',
    href: 'https://nieuwsbrieven.amsterdam.nl/x/plugin/?pName=subscribe&MIDRID=S7Y1MwMAA03&pLang=nl&Z=-974584438',
  },
]

export const FOOTER_LINKS_SOCIAL: ContentLinkHref[] = [
  {
    testId: 'SocialMastodon',
    title: 'Mastodon',
    href: 'https://social.amsterdam.nl/@gemeenteamsterdam',
    icon: 'mastodon',
  },
  {
    testId: 'SocialFacebook',
    title: 'Facebook',
    href: 'https://www.facebook.com/gemeenteamsterdam',
    icon: 'facebook',
  },
  {
    testId: 'SocialLinkedIn',
    title: 'LinkedIn',
    href: 'https://www.linkedin.com/company/gemeente-amsterdam',
    icon: 'linkedin',
  },
  {
    testId: 'SocialGitHub',
    title: 'GitHub',
    href: 'https://github.com/Amsterdam',
    icon: 'github',
  },
]

export const BEDIENING_PAGE: ContentLinkArticle = {
  testId: 'HelpUitlegGebruik',
  title: 'Uitleg gebruik',
  id: {
    acceptance: '5a962d67-ae2d-41b5-9c1a-263591eb5b0c',
    production: '088c348e-73cd-42e0-9998-4123186feded',
  },
  slug: '/uitleg-gebruik',
  icon: 'infoBlack',
}

export const FOOTER_LINKS_HELP: ContentLinkArticle[] = [
  {
    testId: 'HelpFAQ',
    title: 'Veelgestelde vragen',
    id: {
      acceptance: 'a939afed-ff98-4db1-a927-fe6c9bac1ae6',
      production: 'e42a6157-6499-48db-95b6-cb271f7999f7',
    },
    slug: '/veelgestelde-vragen',
    icon: 'chatBubblePeople',
  },
  {
    testId: 'HelpContact',
    title: 'Contact opnemen',
    id: {
      acceptance: 'aadfea20-7308-4caf-9126-a900f9e6df1f',
      production: 'c8f4d1da-75f3-4ee7-93e8-256b201d6ccf',
    },
    slug: '/contact',
    icon: 'email',
  },
  BEDIENING_PAGE,
]

export const FOOTER_LINK_PRIVACY: ContentLinkHref = {
  testId: 'PrivacyCookies',
  title: 'Privacy en cookies',
  href: 'https://www.amsterdam.nl/privacy/',
}

export const HEADER_LINKS_ABOUT: ContentLinkArticle[] = [
  {
    testId: 'OverDeOrganisatie',
    title: 'Over de organisatie',
    id: {
      acceptance: '4dba60f2-7161-4fd8-81e9-03eddb52d259',
      production: '8cf61560-0f90-4b81-84bf-900a6755159d',
    },
    slug: '/over-ons/',
  },
  {
    testId: 'OverHetDataplatform',
    title: 'Over het dataplatform',
    id: {
      acceptance: '29160257-dd4b-4349-a5df-d6f7715615ed',
      production: '8af0598f-12a0-47c5-9327-938fade1159a',
    },
    slug: '/dataplatform-services/',
  },
]

export const HEADER_LINK_CONTACT: ContentLinkArticle = {
  testId: 'OverContact',
  title: 'Contact',
  id: {
    acceptance: 'aadfea20-7308-4caf-9126-a900f9e6df1f',
    production: 'c8f4d1da-75f3-4ee7-93e8-256b201d6ccf',
  },
  slug: '/contact/',
}

export const HEADER_LINK_HELP: ContentLinkArticle = {
  testId: 'HelpHelp',
  title: 'Help',
  id: {
    acceptance: '4e5af47c-a67f-4cbc-be3c-7a0f410a45d6',
    production: 'de7d3101-354c-44f6-b94d-dde572239090',
  },
  slug: '/help',
}

export const NAVIGATION_LINK_DATA_IN_TABLES: ContentLinkArticle = {
  testId: 'Tabellen',
  title: 'Tabellen',
  description: 'Selecteer data en sla op als spreadsheet',
  id: {
    acceptance: '647c0fd0-567e-4157-b7ee-94c7b8504235',
    production: '3f5a9b94-a9d8-417d-aac8-45971f4b3a43',
  },
  slug: '/tabellen',
}

export const NAVIGATION_LINK_DATA_SERVICES: ContentLinkArticle = {
  testId: 'DataServices',
  title: 'Data services',
  description: 'Alles over het koppelen van data via APIs',
  id: {
    acceptance: '42e0c7ce-1694-4468-ae45-ce0e63823a50',
    production: 'bb2dddf3-ddd1-4533-bcce-e33ea00a8a60',
  },
  slug: '/services',
}

export const SHORTLINKS = {
  COLLECTIONS: {
    ECONOMY: {
      id: {
        acceptance: '6216c6bf-4ee1-4a72-a2a8-c00d8606e75b',
        production: '473ee7ce-1219-44f2-836e-90f63da7a751',
      },
    },
    TOURISM: {
      id: {
        acceptance: '21d21e58-aff7-406c-a565-129e1fe1a7cb',
        production: 'fdcc54a1-5aa7-4ddf-af16-1c28a99b8c5f',
      },
    },
    HOUSING: {
      id: {
        acceptance: '5bfec111-c3a8-43c0-9db7-294527d9fbfc',
        production: '2db4e140-6fc2-41e2-bd7b-3f017d00e976',
      },
    },
    EDUCATION: {
      id: {
        acceptance: 'ba42bfa3-4cf6-43ba-bb33-589c5dacefa7',
        production: '400f5adf-a728-4a6d-8dfe-5d14866fb576',
      },
    },
    CORONA: {
      id: {
        acceptance: '054e6a90-f02a-4805-b449-4a7849da38a9',
        production: 'e6d25646-a296-4af9-8081-9fe454db2b02',
      },
    },
    FAQ: {
      id: {
        acceptance: 'a939afed-ff98-4db1-a927-fe6c9bac1ae6',
        production: 'e42a6157-6499-48db-95b6-cb271f7999f7',
      },
    },
  },
}

export const ARTICLE_REDIRECT_FRAGMENTS = {
  ECONOMY_DASHBOARD: {
    from: {
      fragment: {
        acceptance: 'dashboard-kerncijfers-economie/562f52d4-d78a-4d20-94fd-f708f2ba76f7',
        production: 'dashboard-economie-dashboard/3233adae-70ec-413f-90f2-c74a19ab1a34',
      },
    },
    to: {
      fragment: {
        acceptance: 'coronamonitor-dashboard/054e6a90-f02a-4805-b449-4a7849da38a9',
        production:
          'dashboard-gevolgen-corona-voor-amsterdam-dashboard/e6d25646-a296-4af9-8081-9fe454db2b02',
      },
    },
  },
  HELP: {
    from: {
      fragment: {
        acceptance: '4e5af47c-a67f-4cbc-be3c-7a0f410a45d6/',
        production: 'de7d3101-354c-44f6-b94d-dde572239090/',
      },
    },
    to: '/help/',
  },
  ABOUT: {
    from: {
      fragment: {
        acceptance: '4dba60f2-7161-4fd8-81e9-03eddb52d259/',
        production: '8cf61560-0f90-4b81-84bf-900a6755159d/',
      },
    },
    to: '/over-ons/',
  },
  ABOUT_WEBSITE: {
    from: {
      fragment: {
        acceptance: '6b474539-32fb-4a1c-929a-bbfefadadc08/',
        production: 'a5176bed-cad4-46d2-b501-a628370c9099/',
      },
    },
    to: '/over-deze-site/',
  },
  RESEARCH: {
    from: {
      fragment: {
        acceptance: 'bd25761c-ca8c-4587-bdd8-6f77bd8bd7e3/',
        production: '3d7c706a-0898-4adc-b0e8-2c4c195ed7f9/',
      },
    },
    to: 'https://onderzoek.amsterdam.nl/',
  },
  CONTACT: {
    from: {
      fragment: {
        acceptance: 'aadfea20-7308-4caf-9126-a900f9e6df1f/',
        production: 'c8f4d1da-75f3-4ee7-93e8-256b201d6ccf/',
      },
    },
    to: '/contact/',
  },
  ACCESSIBILITY: {
    from: {
      fragment: '1169cb8a-5410-4353-af6c-208cf395f7a0/',
    },
    to: '/toegankelijkheidsverklaring/',
  },
  DATA_CONTACT: {
    from: {
      fragment: '16fd6ce4-43fc-458d-a91a-010602cb046c/',
    },
    to: '/gegevens/',
  },
  QUALITY: {
    from: {
      fragment: '4a2b775e-2296-4d2c-b09d-1cd5d1e3bf94/',
    },
    to: '/beschikbaarheid-kwaliteit-data/',
  },
  STATISTICS: {
    from: {
      fragment: '5b470d46-99b4-4b5e-823a-de15f077f12e/',
    },
    to: 'https://onderzoek.amsterdam.nl/',
  },
  TECHNICAL_MANAGEMENT: {
    from: {
      fragment: '9372b6e3-2997-4c32-9844-83eb3a13cf27/',
    },
    to: '/technisch-beheer-werkwijze/',
  },
  FAQ: {
    from: {
      fragment: 'e42a6157-6499-48db-95b6-cb271f7999f7/',
    },
    to: '/veelgestelde-vragen/',
  },
  FEATURES: {
    from: {
      fragment: '088c348e-73cd-42e0-9998-4123186feded/',
    },
    to: '/uitleg-gebruik/',
  },
  SERVICES: {
    from: {
      fragment: 'bb2dddf3-ddd1-4533-bcce-e33ea00a8a60/',
    },
    to: '/services/',
  },
  TABLES: {
    from: {
      fragment: '3f5a9b94-a9d8-417d-aac8-45971f4b3a43/',
    },
    to: '/tabellen/',
  },
  EMPLOYEES: {
    from: {
      fragment: 'cb7275e3-9bbf-4082-ab76-fd6c436a3ab1/',
    },
    to: '/alleen-voor-medewerkers/',
  },
}
